module.exports = __webpack_public_path__ + "media/images/athletes/1547-1e5ea2ac7fb57d0496d485774b16f2c4.png";